import React from "react";
import { useTranslation } from "react-i18next";
import { getUniqueExercises } from "./blockHelpers";

const BlocksComponent = ({ program, programExercises }) => {
  const { t } = useTranslation("coaching-portal");
  const notSingleWorkout = program.storeType !== "single-workout";

  const renderBlocks = (blocks) => {
    const uniqueExercises =
      programExercises && programExercises.exercises
        ? getUniqueExercises(programExercises.exercises)
        : null;

    return blocks.map((block) => {
      const blockExercises = uniqueExercises
        ? uniqueExercises[block.order]
        : [];

      return (
        <article key={`Block ${block.order}-${block.name}`}>
          <p className="s1">
            {notSingleWorkout
              ? block.name
              : t("learnMoreBlocks.exercisesLabel")}
            :
          </p>

          {blockExercises && blockExercises.length > 0 ? (
            <ul>
              {blockExercises.map((exercise) => (
                <li key={exercise}>
                  <p>{exercise}</p>
                </li>
              ))}
            </ul>
          ) : (
            <span className="no-exercises">
              {notSingleWorkout
                ? t("learnMoreBlocks.noExercisesForBlock")
                : t("learnMoreBlocks.noExercisesForWorkout")}
            </span>
          )}
        </article>
      );
    });
  };

  return program.programs && program.programs.length > 0 ? (
    renderBlocks(program.programs)
  ) : (
    <div className="block-card">
      <p className="s1">{t("learnMoreBlocks.noBlocksFound")}</p>
    </div>
  );
};

export default BlocksComponent;
